"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonDisplayText = SkeletonDisplayText;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _SkeletonText = require("../SkeletonText/SkeletonText");

var _excluded = ["lineHeight", "marginBottom", "numberOfLines", "offsetLeft", "offsetTop", "width"];

function SkeletonDisplayText(_ref) {
  var _ref$lineHeight = _ref.lineHeight,
      lineHeight = _ref$lineHeight === void 0 ? 21 : _ref$lineHeight,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 20 : _ref$marginBottom,
      _ref$numberOfLines = _ref.numberOfLines,
      numberOfLines = _ref$numberOfLines === void 0 ? 1 : _ref$numberOfLines,
      _ref$offsetLeft = _ref.offsetLeft,
      offsetLeft = _ref$offsetLeft === void 0 ? 0 : _ref$offsetLeft,
      _ref$offsetTop = _ref.offsetTop,
      offsetTop = _ref$offsetTop === void 0 ? 0 : _ref$offsetTop,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 100 : _ref$width,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_SkeletonText.SkeletonText, (0, _extends2["default"])({
    lineHeight: lineHeight,
    marginBottom: marginBottom,
    numberOfLines: numberOfLines,
    offsetLeft: offsetLeft,
    offsetTop: offsetTop,
    width: width
  }, otherProps));
}